import { useEffect } from 'react';
import { LEGAL_INFO } from '../legalInfo';

function LegalPage({ title, intro, sections, related }) {
  useEffect(() => {
    document.title = `${title} · EbiTrade`;
  }, [title]);

  return (
    <article className="legal">
      <header className="legal__header">
        <span className="legal__tag">Legal</span>
        <h1 className="legal__title">{title}</h1>
        <p className="legal__updated">Última actualización: {LEGAL_INFO.lastUpdated}</p>
        {intro && <p className="legal__intro">{intro}</p>}
      </header>

      <div className="legal__body">
        <nav className="legal__toc" aria-label="Contenido del documento">
          <h2 className="legal__toc-title">Contenido</h2>
          <ol>
            {sections.map((section) => (
              <li key={section.id}>
                <a href={`#${section.id}`}>{section.title}</a>
              </li>
            ))}
          </ol>
        </nav>

        <div className="legal__content">
          {sections.map((section, index) => (
            <section key={section.id} id={section.id} className="legal__section">
              <h2>
                {index + 1}. {section.title}
              </h2>
              {section.content}
            </section>
          ))}

          {related && (
            <p className="legal__related">
              Consulta también: <a href={related.href}>{related.label}</a>.
            </p>
          )}
        </div>
      </div>
    </article>
  );
}

export default LegalPage;
